import { gql } from "@apollo/client";
import { COURSE_FRAGMENT, PLAN_FRAGMENT, SERIES_FRAGMENT } from "../fragments";

export const GET_USER_DETAILS = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  ${PLAN_FRAGMENT}
  query GetUserDetails {
    currentUser {
      email
      firstName
      lastName
      dateOfBirth
      mobileNumber
      college
      dateOfBirth
      getChargebeeId
      getSubscriptionDetails
      isUserSubscribed
      profilePicture {
        filename
        url
      }
      location {
        id
        name
        parent {
          name
        }
      }
      activeCart {
        uuid
        discountAmount
        subTotalAmount
        totalAmount
        nsdcAmount
        taxAmount
        cartItems {
          uuid
          discountAmount
          subTotalAmount
          totalAmount
          itemable {
            __typename
            ...CourseFragment
            ...SeriesFragment
            ...PlanFragment
          }
          nsdcIncluded
          nsdcPrice
          nsdcOrignalPriceCart
        }
        coupon {
          code
          description
          discount
        }
      }
    }
  }
`;
